import { render, staticRenderFns } from "./joinOus.vue?vue&type=template&id=27425732&scoped=true"
import script from "./joinOus.vue?vue&type=script&lang=js"
export * from "./joinOus.vue?vue&type=script&lang=js"
import style0 from "./joinOus.vue?vue&type=style&index=0&id=27425732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27425732",
  null
  
)

export default component.exports